import type { BranchCode, Domain } from "~/types";
import { includes } from "./general";
import { DOMAINS, TEST_SUBDOMAIN } from '../assets/constants';
import { getBranchByCode } from "./branch";
import { isDev, isTest } from "./environment";

const FALLBACK_DOMAIN: Domain = 'visanet.co';
const COMPANY_DOMAINS = DOMAINS.filter(domain => !isLocalhost(domain));

export function getDomainByBranch(branch: BranchCode): Domain {
  if (isDev()) return 'localhost:3000';
  const { domain } = getBranchByCode(branch);
  return isTest() ? toTestDomain(domain) : domain;
}

export function toProductionDomain(domain: Domain) {
  return domain.replace(TEST_SUBDOMAIN + '.', '') as Domain;
}

export function isCompanyDomain(domain: string) {
  return includes(COMPANY_DOMAINS, domain);
}

export function getFallbackDomain() {
  return isTest() ? toTestDomain(FALLBACK_DOMAIN) : FALLBACK_DOMAIN;
}

function toTestDomain(domain: Domain) {
  return `${TEST_SUBDOMAIN}.${domain}` as Domain;
}

function isLocalhost(domain: Domain) {
  return domain == 'localhost:3000';
}